import { Component, OnInit, Input } from '@angular/core';
import { UserService } from 'src/app/modules/userModule/shared/user.service';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';
import { RatedAssets } from 'src/app/models/ratedAssets';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.css']
})
export class RatingComponent implements OnInit {

  @Input()
  rating: number;
  @Input()
  aseetId: string;
  enable: number;
  ans: boolean = false;
  unrated: number = 1;
  un: number = 1;
  tmp: RatedAssets;
  flag: number = 0;
  selectedVersion: string;
  isShowNotificationSuccess: boolean;
  showSuccessMessage: string;

  constructor(public userService: UserService, private httpService: HttpService) {
    this.httpService.reloadRating.subscribe(() => {
      this.rating = this.httpService.avgRt;
      if (!this.allowToRate()) {
        this.disableRating();
      } else {
        this.ans = false;
        this.un = 1;
      }
    });
  }

  ngOnInit() {
    this.enable = 0;
    this.httpService.avgRt = this.rating;
  }

  enableRating() {
    this.enable = 1;
    this.ans = true;
    this.unrated = 0;
    this.un = 0;
    if (this.userService.loggendInUser.assetsRated) {
      console.log(this.aseetId);
      let value: boolean = this.userService.loggendInUser.assetsRated.filter(asset => asset.assetId === this.aseetId && asset.assetVersion === this.httpService.selectedVersionNumber).length === 1;
      if (value) {
        this.disableRating();
      } else {
        this.rating = 0;
      }
    }
  }

  disableRating() {
    this.enable = 0;
    this.ans = false;
    this.unrated = 1;
    this.un = 1;
    this.rating = this.httpService.avgRt;
  }

  allowToRate() {
    if (this.userService.loggendInUser.assetsRated) {
      let value: boolean = this.userService.loggendInUser.assetsRated.filter(asset => asset.assetId === this.aseetId && asset.assetVersion === this.httpService.selectedVersionNumber).length === 1;
      if (value) {
        return false;
      }
    }
    return true;
  }

  setRating(rating) {
    let oldRating = this.rating;
    this.rating = rating;
    let assetId = this.aseetId ? this.aseetId : null
    if (this.rating != 0) {
      let feedback = {
        assetVersion: this.httpService.selectedVersionNumber,
        userEmail: this.userService.loggendInUser.userEmailId,
        rating: this.rating
      };
      this.userService.setRating(feedback, assetId).subscribe(
        (data: any) => {
          if (null != data) {
            // alert('Ratings updated!');
            this.successNotification('Ratings Updated!');
            this.tmp = new RatedAssets();
            this.tmp.assetId = assetId;
            this.tmp.assetVersion = feedback.assetVersion;
            if (!this.userService.loggendInUser.assetsRated) {
              this.userService.loggendInUser.assetsRated = [];
            }
            this.userService.loggendInUser.assetsRated.push(this.tmp);
            sessionStorage.setItem('userinfo', JSON.stringify(this.userService.loggendInUser));
            this.httpService.assetDetails.avgRt = data[1];
            this.httpService.assetDetails.noOfRatings = data[0];
            this.httpService.avgRt = data[1];
            this.rating = data[1];
            this.un = 1;
          }
          else {
            alert('You have already rated this asset version!');
            this.disableRating();
            this.rating = oldRating;
          }
        }
        ,
        err => {
          console.log(err);
        }
        ,
        () => {
          this.ans = false;
          this.getStars(this.rating);
        }
      );
    }

  }

  getStars(rtng) {
    var val = rtng;
    var size = val / 5 * 100;
    return size + '%';
  }

  successNotification(message) {
    this.isShowNotificationSuccess = true;
    this.showSuccessMessage = message;
    setTimeout(() => {
      this.isShowNotificationSuccess = false;
    }, 5000);
  }

}
